import { render, staticRenderFns } from "./LabelGenerationPlugin.vue?vue&type=template&id=34316d8c&"
import script from "./LabelGenerationPlugin.vue?vue&type=script&lang=ts&"
export * from "./LabelGenerationPlugin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports